import React from 'react'

const PieLabel = () => {
  const data = [
    {color: 'bg-sky-400', label: 'A (Skor 85 - 100)'},
    {color: 'bg-emerald-400', label: 'B (Skor 75 - 84)'},
    {color: 'bg-yellow-400', label: 'C (Skor 60 - 74)'},
    {color: 'bg-red-400', label: 'D (Skor 50 - 59)'},
    {color: 'bg-violet-400', label: 'E (Skor 0 - 49)'},
  ]
  return (
    <div className="space-y-2">
      {
        data.map((item, i) => (
          <div className="flex items-center gap-2" key={i}>
            <div className={`w-5 h-5 ${item.color}`}></div>
            <span className="text-sm">{item.label}</span>
          </div>
        ))
      }
    </div>
  )
}

export default PieLabel